import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class LicenseMgtService {

  constructor(private http: HttpClient) { }

  ReadLicenseMgt(otp): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/license/mgt/read`, {otp: otp});
  }

  AddLicenseMgt(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/license/mgt/add`, params);
  }

  UpdateLicenseMgt(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/license/mgt/update`, params);
  }

  DeleteLicenseMgt(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/license/mgt/delete`, params);
  }

  ReadLicenseMgtList(param): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/license/mgt/list/read`, param);
  }

  DeleteLicenseMgtList(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/license/info/delete`, params);
  }

  ReadLicenseDetails(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/license/detail/read`, params);
  }

  CheckLicense(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/license/check`, params);
  }

  ActivateLicense(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/license/activate`, params);
  }

  ActivateTrialLicense(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/license/trial/activate`, params);
  }

  BindLicenseSN(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/license/info/bind`, params);
  }

  StopLicense(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/license/stop`, params);
  }

  ConfirmLicense(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/license/mgt/confirm`, params);
  }

  ReadLicenseTrialMgt(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/license/trial/mgt/read`, params);
  }

  AddLicenseTrialMgt(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/license/trial/mgt/add`, params);
  }

  UpdateLicenseTrialMgt(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/license/trial/mgt/update`, params);
  }

  DeleteLicenseTrialMgt(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/license/trial/mgt/delete`, params);
  }

  ReadSWLicenseType(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/sw/type/read`, params);
  }

  ReadSWLicense(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/sw/license/read`, params);
  }

  ReadSWLicenseList(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/sw/license/list`, params);
  }

  AddSWLicense(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/sw/license/add`, params);
  }

  UpdateSWLicense(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/sw/license/update`, params);
  }

  DeleteSWLicense(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/sw/license/delete`, params);
  }

  SendSWLicenseMail(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/sw/license/mail/send`, params);
  }

  ConfirmSWLicense(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/sw/license/confirm`, params);
  }
}
